module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicCondensed-Regular-db0eb27f0e48f1228d8fda3a1ea47a84.ttf";